import { Injectable, signal } from '@angular/core';
import { CreatorResponseDto } from '../../common/general-types/creators.dto';
import { ApplicationStatusEnum } from '../../common/general-types/briefs.dto';

export type CollaboratorSelectionGuide = {
  nonce: number;
  originX: number;
  originY: number;
};

@Injectable({
  providedIn: 'root'
})
export class CollaboratorService {

  showCollaborators = signal<boolean>(false);
  selectedCreators = signal<CreatorResponseDto[]>([]);
  briefId = signal<string | undefined>(undefined);
  /** Creators who already have an application on `briefId`, by Firebase UID → application status. */
  briefApplicationStatuses = signal<ReadonlyMap<string, number>>(new Map());
  selectionGuide = signal<CollaboratorSelectionGuide | null>(null);

  private selectionGuideNonce = 0;

  /** Records new invites on `briefId` so its search results swap Invite for a status badge. */
  markInvited(briefId: string, creatorUids: string[]): void {
    if (briefId !== this.briefId() || creatorUids.length === 0) {
      return;
    }
    const next = new Map(this.briefApplicationStatuses());
    for (const uid of creatorUids) {
      if (!next.has(uid)) {
        next.set(uid, ApplicationStatusEnum.Invited);
      }
    }
    this.briefApplicationStatuses.set(next);
  }

  triggerSelectionGuide(origin: DOMRect): void {
    this.selectionGuideNonce += 1;
    this.selectionGuide.set({
      nonce: this.selectionGuideNonce,
      originX: origin.left + origin.width / 2,
      originY: origin.top + origin.height / 2,
    });
  }

  selectCreator(creator: CreatorResponseDto) {
    if (this.selectedCreators()?.includes(creator)) {
      this.removeCreator(creator);
    } else {
      this.selectedCreators.set([...this.selectedCreators(), creator]);
    }
    console.log('💙💙💙 selectedCreators: ', this.selectedCreators().length);
  }

  removeCreator(creator: CreatorResponseDto) {  
    this.selectedCreators.set(this.selectedCreators()?.filter((c: CreatorResponseDto) => c.blazeFirebaseUid !== creator.blazeFirebaseUid) || []);
  }
}
